import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import ProfileDetails from "./ProfileDetails";
import SubscriptionDetails from "./UserSubscriptionDetails";
import { Helmet } from "react-helmet";

function UserProfile() {
  return (
    <>
      <Helmet>
        <title>Profile | EMAlpha</title>
      </Helmet>
      <div className="flex " style={{ height: "8%" }}></div>
      <div
        className=" bg-white p-3 bg-white rounded-4 rounded-left"
        style={{ height: "92%" }}
      >
        <div
          className="UserProfile container mt-2 "
          style={{ height: "100%", overflow: "auto" }}
        >
          <Tabs
            defaultActiveKey="profile"
            id="uncontrolled-tab-example"
            className="mb-3 "
          >
            <Tab
              eventKey="profile"
              title="Profile"
              className=" boder p-2 border-right"
            >
              <ProfileDetails />
            </Tab>
            <Tab
              eventKey="subscription"
              title="Subscription"
              className=" boder p-2 border-right"
            >
              <SubscriptionDetails />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default UserProfile;
